export type FieldData = {
  text?: string;
  count: number;
};

export type FooterData = {
  text?: string;
  date: Date;
};

export type FieldHeader = {
  icon: React.ReactNode;
  text: string;
};

export enum DataContextContentFieldType {
  SYSTEM = 'system',
  USER = 'user',
  PURCHASE = 'purchase',
  CUSTOM = 'custom',
}

export type DataContextMenuProps = {
  /** Text description providing additional context about the event. */
  description?: string;
  /** Various SystemEventName or EventTypes sent from the data */
  event: DataContextContentFieldType;
  /** Customiziable array with objects of count and text */
  fieldData: FieldData[];
  /** Customiziable object that stores icon and heading text */
  fieldHeader: FieldHeader;
  /** Display name for the field in question */
  fieldDisplayName: string;
  /** Optional: To display 'days ago' footer section */
  fieldFooter?: FooterData;
  /** Boolean to show error State */
  isError: boolean;
  /** Boolean to show loading State */
  isLoading: boolean;
  /** Optional: if you want to display Sample Value inside Context Menu */
  sampleValue?: string;
  /** Optional: if you want enable or disable last refresh tooltip */
  isLastRefreshTooltipEnabled?: boolean;
};
